export default __webpack_public_path__ + "static/media/icon_recommend-product.88d08ecb.svg";